import { z } from "zod";
import { channelWidgetRecordsSchema } from "./channel-widget-records.js";
/** Empty path selects all rows; null column selects all displayed columns. Labels are the full grouping path. */
export const channelMatrixRecordsSelectionSchema = z.object({
    rowPath: z.array(z.string()).max(3),
    columnKey: z.string().min(1).nullable(),
    measureId: z.string().trim().min(1).max(120),
}).strict();
/** Pivot record pages share the chart record contract, replacing the widget identity with the selected figure. */
export const channelMatrixRecordsSchema = channelWidgetRecordsSchema.omit({ widgetId: true, point: true }).extend({
    schemaVersion: z.literal("mlx.channel-matrix-records.v1"),
    viewId: z.string().trim().min(1),
    selection: channelMatrixRecordsSelectionSchema,
});
